// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-370eb41c] .van-nav-bar{height:12.8vw}[data-v-370eb41c] .van-nav-bar .van-nav-bar__content{line-height:12.8vw;height:12.8vw}[data-v-370eb41c] .van-nav-bar .van-nav-bar__content .van-nav-bar__title{font-size:4.8vw;color:#212121}[data-v-370eb41c] .van-nav-bar .van-nav-bar__content .van-icon{font-size:5.333vw;color:#212121;right:.533vw}.box[data-v-370eb41c]{padding:4vw 4vw 13.333vw;font-size:4.267vw;color:#212121;text-align:center}.title[data-v-370eb41c]{text-indent:2em}", ""]);
// Exports
module.exports = exports;
